<div class="page-padding">
    <div class="panel" (click)="hideContextMenu($event)">
        <div class="panel__header">
            <span class="panel__header__title">{{title}}</span>
        </div>
        <div class="panel__content center-content" *ngIf="setupComplete" [@fadeInOut]>
            <div class="setup-complete-container">
                <div class="setup-complete__header">Setup Complete! </div>
                <i class="material-icons large-check">check_circle</i>
                <div class="set-complete__sub-header">Would you like to setup another implement ? </div>
                <div class="button-container">
                    <button mat-raised-button color="warn" (click)="navigateToSetupImplements()">Yes, I want to setup
                        another implement</button>
                    <button mat-raised-button (click)="navigateToMyImplements()">No, take me to my dashboard</button>
                </div>
            </div>
        </div>







        <mat-horizontal-stepper *ngIf="!setupComplete" [linear]="isLinear" [selectedIndex]="currentStep"
            editable="false" #stepper>
            <mat-step>
                <ng-template matStepLabel>Create Implement</ng-template>
                <div class="step-container">

                    <div style="display: flex; flex-direction: column ;width: 50%;">
                        <span style=" font-weight: bold;">1. Select Customer and Jobsite</span>
                        <div style="display: flex; flex-direction: row;margin-top: 1%;">
                            <mat-form-field style="width: 100%">
                                <mat-select id="customer" [(ngModel)]="selectedCustomer" placeholder="Select Customer"
                                    (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl required>
                                    <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
                                        {{customer.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field style="width: 100%">
                                <mat-select id="jobsite" placeholder="Select Job Site" [(ngModel)]="selectedJobsite"
                                    (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl required>
                                    <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                                        {{jobsite.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <div style="padding-left: 30%;  position: absolute;left: 50%; margin-top: -2%;">
                                <input hidden type='file' (change)="onSelectImplementPhoto($event)"
                                    #uploadImplementImage>

                                <ng-container *ngIf="!implementImage">
                                    <div class="add-implement-image-container" (click)="uploadImplementImage.click()">
                                        <i class="material-icons add-implement-image-icon">add_box</i>
                                        <div class="add-implement-image-label">Add Implement Image</div>

                                    </div>
                                </ng-container>

                                <ng-container *ngIf="implementImage?.length > 0">
                                    <div class="implement-image-container image-offset-left">
                                        <img [src]="getImage(implementImage)"
                                            style="width: 200px;height: 200px; margin-top: -6%;"
                                            (click)="openEnlargedImage(implementImage, 1)"
                                            matTooltip="Click to view enlarged image." />
                                        <div>
                                            <button mat-raised-button style="background:white "
                                                (click)="uploadImplementImage.click()">Update Image</button>
                                            <button *ngIf="!isNewImplement" mat-raised-button
                                                (click)="deleteImplementImage()" style="margin-left: 3px;">Delete
                                                Image</button>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>


                    <div style="    margin-top: 1%;margin-bottom: 0;">
                        <mat-radio-group [(ngModel)]="equipmentOrInventory" ngDefaultControl
                            [ngModelOptions]="{standalone: true}">
                            <mat-radio-button [value]="1" (click)="loadOntoEquipment()" labelPosition="before"><b>2. Add
                                    to Equipment</b></mat-radio-button>
                            <mat-radio-button [value]="2" (click)="createInInventory()" labelPosition="before"><b>Jobsite
                                    Inventory</b></mat-radio-button>
                            <mat-radio-button [value]="3" (click)="createInTemplate()" labelPosition="before"><b>Template
                                </b></mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div *ngIf="equipmentOrInventory=='1'"
                        style="display: flex; flex-direction: row;margin-top: 1%; width: 50%;">

                        <mat-form-field style="width: 100%">
                            <mat-select id="jobsite" placeholder="Serial / Unit Number" [(ngModel)]="selectedEquipment"
                                ngDefaultControl required (selectionChange)="onSelectEquipment()">
                                <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                                    {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field style="width: 100%">
                            <input matInput placeholder="Equipment SMU at Setup" type="number"
                                [(ngModel)]="equipmentSMU" (keypress)="ValidateNumberInputs($event)" ngDefaultControl
                                required [disabled]="!canChangeHoursAndDate">
                            <span matSuffix>Hours</span>
                        </mat-form-field>
                    </div>

                    <div *ngIf="equipmentOrInventory=='3'"
                        style="display: flex; flex-direction: row;margin-top: 1%; width: 75%;">

                        <mat-form-field style="width: 100%;">
                            <mat-select id="select-family" placeholder="Select Family" [(ngModel)]="selectedFamily"
                                (selectionChange)="LoadModels()" ngDefaultControl multiple>
                                <mat-option [value]="type.Id"
                                    *ngFor="let type of _favouriteDialogService.availableFamilyList">
                                    {{type.Name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field style="width: 100%;">
                            <mat-select id="select-family" placeholder="Select Make" [(ngModel)]="selectedMakes"
                                (selectionChange)="LoadModels()" ngDefaultControl multiple>
                                <mat-option [value]="make.Id" *ngFor="let make of makeList">
                                    {{make.Name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field style="width: 100%;">
                            <mat-select id="select-family" placeholder="Select Model" [(ngModel)]="selectedModels"
                                ngDefaultControl required multiple>
                                <mat-option [value]="model.Id" *ngFor="let model of modelList_">
                                    {{model.Name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>


                    <div style="display: flex; flex-direction: column ;width: 78%;">
                        <span style=" font-weight: bold;">3.Select Type of Implement</span>
                        <div style="display: flex; flex-direction: row;margin-top: 1%;">
                            <mat-form-field style="width: 100%">
                                <mat-select id="implementType" [(ngModel)]="selectedImplementType"
                                    placeholder="Select Implement Type" (selectionChange)="onImplementTypeSelected()"
                                    ngDefaultControl required [disabled]="newOrExistingOption=='2'">
                                    <mat-option [value]="implementType.TemplateId"
                                        *ngFor="let implementType of implementTypeList">
                                        {{implementType.TemplateName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <div *ngIf="newOrExistingOption=='1'" style="align-self: center; padding-right: 32px;">
                                <a style="cursor: pointer;color: #5D7FF9;" (click)="addNewImplementType()"
                                    title="Add New Implement Type">
                                    <i class="material-icons button__icon" style="font-weight: bold;"> add</i></a>
                            </div>


                            <mat-form-field style="width: 100%">
                                <input matInput placeholder="Bucket Capacity" id="bucketCapacity" type="number"
                                    [(ngModel)]="bucketCapacity" ngDefaultControl>
                                <span matSuffix>m³</span>
                            </mat-form-field>

                            <mat-form-field style="width: 100%">
                                <mat-select id="selectedGETType" [(ngModel)]="selectedGETType"
                                    placeholder="Select GET Type" ngDefaultControl>
                                    <mat-option [value]="make.Id" *ngFor="let make of makeList">
                                        {{make.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>



                        </div>
                    </div>

                    <div style="display: flex; flex-direction: column ;width: 78%;">
                        <span style=" font-weight: bold;">4. Enter Implement Serial Number</span>
                        <div style="display: flex; flex-direction: row;margin-top: 1%;">
                            <mat-form-field style="width: 100%" *ngIf="newOrExistingOption=='1'">
                                <input matInput placeholder="Implement Serial Number" id="serialNumber" type="text"
                                    (blur)="validateImplementSerial()" [(ngModel)]="serialNumber" ngDefaultControl
                                    required (keydown.space)="$event.preventDefault();">
                            </mat-form-field>


                            <ng-container *ngIf="newOrExistingOption=='2'">

                                <mat-form-field style="width: 100%">
                                    <mat-select id="attachedImplement" [(ngModel)]="selectedImplement"
                                        placeholder="Select Implement" (selectionChange)="onImplementSelected()" ngDefaultControl
                                        required>
                                        <mat-option value="0"></mat-option>
                                        <mat-option [value]="impl.Id" *ngFor="let impl of implementList">
                                            {{impl.Name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <div *ngIf="newOrExistingOption=='2' && selectedImplement>0"
                                    style="align-self: center; padding-right: 32px;">
                                    <a style="cursor: pointer;color: #5D7FF9;"
                                        (click)="EditImplementSerial(selectedImplement)" title="Edit Implement Serial">
                                        <i class="material-icons button__icon" style="font-weight: bold;"> edit</i></a>
                                </div>


                            </ng-container>

                            <mat-form-field style="width: 100%">
                                <input matInput placeholder="Additional Serial #" id="Additional_serial_num" type="text"
                                    [(ngModel)]="Additional_serial_num" ngDefaultControl>
                            </mat-form-field>


                            <mat-form-field style="width: 100%">
                                <mat-select id="make" [(ngModel)]="selectedMake" placeholder="Implement Make"
                                    ngDefaultControl>
                                    <mat-option value="0"></mat-option>
                                    <mat-option [value]="make.Id" *ngFor="let make of makeList">
                                        {{make.Name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>


                            <mat-form-field style="width: 100%">
                                <input matInput placeholder="Hours on Implement at Setup" id="implementHours"
                                    type="number" min="0" [(ngModel)]="implementHours"
                                    (keypress)="ValidateNumberInputs($event)" ngDefaultControl required
                                    [disabled]="!canChangeHoursAndDate">
                                <span matSuffix>Hours</span>
                            </mat-form-field>


                        </div>
                    </div>

                    <div style="display: flex; flex-direction: column ;width: 78%;">
                        <span style=" font-weight: bold;">5. Budget</span>
                        <div style="display: flex; flex-direction: row;margin-top: 1%;">

                            <mat-form-field style="width: 100%">
                                <input matInput id="budget" placeholder="Budget at Setup" type="number"
                                    [(ngModel)]="budgetHrs" ngDefaultControl>
                                <span matSuffix>Hours</span>
                            </mat-form-field>

                            <mat-form-field style="width: 100%">
                                <input matInput id="bcm" placeholder="BCM at Setup" type="number" [(ngModel)]="bcmHrs"
                                    ngDefaultControl>
                                <span matSuffix>m³</span>
                            </mat-form-field>
                            <mat-form-field style="width: 100%">
                                <input matInput id="ton" placeholder="Implement Tons at Setup" type="number"
                                    [(ngModel)]="tonHrs" ngDefaultControl>
                                <span matSuffix>Tons</span>
                            </mat-form-field>


                        </div>
                    </div>


                    <div style="display: flex; flex-direction: column ;width: 78%;">
                        <span style=" font-weight: bold;">6. Date of Setup</span>
                        <div style="display: flex; flex-direction: row;margin-top: 1%;">

                            <mat-form-field style="width: 32%;">
                                <input matInput [matDatepicker]="startDatePicker" placeholder="Date of Setup"
                                    [(ngModel)]="dateOfReading" (click)="canChangeHoursAndDate ? picker.open() : null">
                                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>


                        </div>
                    </div>

                    <div style="display: flex; flex-direction: column ;width: 78%;">
                        <span style=" font-weight: bold;">7. Purchased Cost</span>
                        <div style="display: flex; flex-direction: row;margin-top: 1%;">

                            <mat-form-field style="width: 32%;">
                                <input matInput id="cost" placeholder="Implement Purchased Cost" type="number" min="0"
                                    [(ngModel)]="purchaseCost" ngDefaultControl>
                                <span matPrefix>$</span>
                            </mat-form-field>

                        </div>
                    </div>

                    <div>
                        <button mat-raised-button color="warn" (click)="goToStep(1)"
                            [disabled]="loadingExistingEquipment"
                            [class.loading]="loadingExistingEquipment">Next</button>
                    </div>
                </div>
            </mat-step>


            <mat-step>
                <div class="step-container">
                    <ng-template matStepLabel>Components Setup</ng-template>

                    <div>


                        <!--schemantic images adding-->
                        <div class="margin-bottom-24" style="overflow-x: auto; white-space: nowrap">
                            <input hidden type='file' (change)="onSelectSchematicPhoto($event)" #uploadSchematicImage>

                            <ng-container>
                                <div class="add-new-schematic" (click)="uploadSchematicImage.click()"
                                    style="float: left;"
                                    matTooltip="Click to upload a schematic image (JPG format recommended)">
                                    <i class="material-icons add-new-schematic__icon">add_box</i>
                                    <div class="add-new-schematic__text">Add new</div>
                                </div>

                                <ng-container *ngFor="let sch of schematicList">
                                    <div class="implement-image-container2 " (click)="openSchematicWindow(sch, 2)"
                                        matTooltip="Click to view enlarged schematic.">
                                        <img [src]="getImage(sch.Data)" class="selection__image"
                                            style="width: 100%; height: 100%; margin-left: 22px;" />
                                    </div>
                                    <mat-icon *ngIf="sch.ObservationPoints.length==0"
                                        style="margin-left: 14px; cursor: pointer;"
                                        (click)="deleteimage(sch.Id,sch.IsNewImage,sch.ObservationPoints)">delete
                                    </mat-icon>
                                </ng-container>

                                <div id="ulSchematics" class="selection-container">

                                </div>
                            </ng-container>
                        </div>



                        <div class="question">
                            <div class="question__text">Add Components to Implement</div>


                            <mat-form-field style="width: 20%">
                                <input matInput (keyup)="onComponentListFilterChange()" type="text"
                                    placeholder="Filter list" [(ngModel)]="componentListFilter" ngDefaultControl>
                            </mat-form-field>


                            <!-- <input class="no-grow" (keyup)="onComponentListFilterChange()" type="text"
                            placeholder="Filter list" [(ngModel)]="componentListFilter" /> -->

                            <mat-checkbox id="cbHideSelectedMPs" color="primary" (checked)="hideSelectedMPs"
                                (click)="toggleSelectedMPs()">Hide Selected</mat-checkbox>
                            <mat-checkbox id="cbHideUnselectedMPs" color="primary" (checked)="hideUnselectedMPs"
                                (click)="toggleUnselectedMPs()">Hide Unselected</mat-checkbox>

                            <div class="question__control">
                                <div>
                                    <div style="display: flex; margin-top: 16px; margin-bottom: 8px">
                                        <mat-checkbox id="cbOPComponent_isActive" color="primary"
                                            [(ngModel)]="cbAllComponentsSelect"
                                            (click)="toggleAllComponents(!cbAllComponentsSelect)"
                                            style="margin-left: 32px!important; margin-right: 16px!important;align-self: center">
                                        </mat-checkbox>
                                        <div class="ComponentHeader center-align-text"><b>Component Name</b></div>
                                        <div class="ComponentHeader center-align-text"><b>Make</b></div>
                                        <div class="ComponentHeader center-align-text"><b>Part No.</b></div>
                                        <div class="ComponentHeader center-align-text"><b>Type</b></div>
                                        <div class="ComponentHeader center-align-text"><b>Budget Life</b></div>
                                        <div class="ComponentHeader" style="min-width: 100px;"><b style="vertical-align: top;">Is Critical</b> <i
                                                style="cursor: default;"
                                                title="Components marked as critical contribute to the overall evaluation of the implement"
                                                class="material-icons">help</i></div>
                                        <div class="ComponentHeader"><b style="vertical-align: top;">GET</b> 
                                                </div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <div class="select-list--overflow">
                                        <mat-selection-list #componentTypeListId style="width: 100%;">
                                            <ng-container *ngFor="let component of componentListFiltered">
                                                <mat-list-item *ngIf="selectionLogicForMPs(component.Selected)">
                                                    <div style="display: flex; margin-top: 8px; margin-bottom: 8px;">
                                                        <mat-checkbox
                                                            id="chkComponent-{{component.Id}}-{{component.IsNew}}"
                                                            [checked]="component.Selected" [value]="component.Id"
                                                            style="margin-left: 16px!important; margin-right: 16px!important;"
                                                            color="primary"
                                                            (change)="onComponentListControlChanged(component.Id, component.Name)">
                                                        </mat-checkbox>
                                                        <div class="ComponentHeader">
                                                            <input class="newCompInput_Select" id="ComponentName"
                                                                placeholder="Name" type="text" style="min-width: 200px;height: 40px;display: inline !important; background-color: #F4F7FA;
                                                            color: #1D2F36; min-height: 40px; padding: 10px;"
                                                                [(ngModel)]="component.Name" class="length-input3"
                                                                ngDefaultControl required>


                                                        </div>
                                                        <div class="ComponentHeader">
                                                            <select class="newCompInput_Select" id="ComponentMake"
                                                                placeholder="Select Make" style="min-width: 200px;height: 40px;display: inline !important; background-color: #F4F7FA;
                                                        color: #1D2F36; min-height: 40px; padding: 10px;"
                                                                [(ngModel)]="component.MakeId" ngDefaultControl required
                                                                class="length-input3">
                                                                <option value="0"></option>
                                                                <option [value]="make.Id" *ngFor="let make of makeList">
                                                                    {{make.Name}}
                                                                </option>
                                                            </select>
                                                        </div>
                                                        <div class="ComponentHeader">
                                                            <input class="newCompInput_Select" id="ComponentPartNo"
                                                                placeholder="PartNo" type="text" style="min-width: 200px;height: 40px;display: inline !important; background-color: #F4F7FA;
                                                        color: #1D2F36; min-height: 40px; padding: 10px;"
                                                                [(ngModel)]="component.PartNo" class="length-input3"
                                                                ngDefaultControl required>
                                                        </div>

                                                        <div class="ComponentHeader">
                                                            <select class="newCompInput_Select" id="ComponentType"
                                                                placeholder="Select Type" style="min-width: 200px;height: 40px;display: inline !important; background-color: #F4F7FA;
                                                        color: #1D2F36; min-height: 40px; padding: 10px;"
                                                                [(ngModel)]="component.CompTypeId" ngDefaultControl
                                                                required class="length-input3">
                                                                <option value="0"></option>
                                                                <option [value]="type.Id"
                                                                    *ngFor="let type of componentTypeList">
                                                                    {{type.Name}}
                                                                </option>
                                                            </select>
                                                        </div>

                                                        <div class="ComponentHeader">
                                                            <input class="newCompInput_Select" id="ComponentBudgetLife"
                                                                placeholder="Budget Life" type="text" style="min-width: 200px;height: 40px;display: inline !important; background-color: #F4F7FA;
                                                            color: #1D2F36; min-height: 40px; padding: 10px;"
                                                                [(ngModel)]="component.CompBudgetLife"
                                                                class="length-input3" ngDefaultControl required>
                                                        </div>

                                                        <div class="ComponentHeader_Arrow">
                                                            <mat-checkbox
                                                                id="chkComponentCritical-{{component.Id}}-{{component.IsNew}}"
                                                                [checked]="component.IsCritical" [value]="component.Id"
                                                                style="margin-left: 16px!important; margin-right: 16px!important;-webkit-text-emphasis-style: filled;"
                                                                color="primary"
                                                                (change)="onComponentCriticalChange($event,component.Id,component)">
                                                            </mat-checkbox>
                                                        </div>

                                                        <div class="ComponentHeader">
                                                            <mat-checkbox
                                                                
                                                                [checked]="component.isGETCritical" [value]="component.Id"
                                                                style="margin-left: 16px!important; margin-right: 16px!important;-webkit-text-emphasis-style: filled;"
                                                                color="primary"
                                                                (change)="onGETComponentCriticalChange($event,component.Id,component)">
                                                            </mat-checkbox>
                                                        </div>

                                                        <span title="Move up"
                                                            class="input-icon image-icon-padding sort-component-icon"
                                                            style="margin-right: 16px!important"
                                                            [class.button-hide]="isFirstComponentInList(component.Id)"
                                                            (click)="recalculateSortOrder(component.Id, false, component.IsNew)">
                                                            <i class="material-icons">arrow_upward</i>
                                                        </span>
                                                        <span title="Move down"
                                                            class="input-icon image-icon-padding sort-component-icon"
                                                            style="margin-right: 16px!important"
                                                            [class.button-hide]="isLastComponentInList(component.Id)"
                                                            (click)="recalculateSortOrder(component.Id, true, component.IsNew)">
                                                            <i class="material-icons">arrow_downward</i>
                                                        </span>

                                                        <span *ngIf="component.IsNew" title="Delete"
                                                            class="input-icon image-icon-padding"
                                                            (click)="deleteNewComponent(component.Id)">
                                                            <i class="material-icons">delete</i>
                                                        </span>
                                                    </div>
                                                </mat-list-item>
                                            </ng-container>
                                        </mat-selection-list>
                                        <div style="visibility: hidden; margin-top: 24px; " #scrollTarget>.</div>
                                    </div>
                                </div>
                                <span>Add Component</span>
                                <div class="input-container"
                                    style="margin-left: 63px;display: flex;flex-direction: row;">

                                    <input type="text" class="newcomps newCompInput_Select"
                                        style="margin-right: 23px!important;"
                                        (keyup.enter)="addNewComponent(scrollTarget)" placeholder="Enter Component name"
                                        [(ngModel)]="newComponentName" />

                                    <select id="make" class="newcomps"
                                        style="margin-right: 23px!important;  min-width: 200px;height: 40px; 
                                display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                        placeholder="Select Make" [(ngModel)]="newComponentMakeId" ngDefaultControl
                                        required class="select-measurement-point">
                                        <option value="0"></option>
                                        <option [value]="make.Id" *ngFor="let make of makeList">
                                            {{make.Name}}
                                        </option>
                                    </select>

                                    <input type="text" class="newcomps newCompInput_Select"
                                        style="margin-right: 23px!important;"
                                        (keyup.enter)="addNewComponent(scrollTarget)" placeholder="Enter Part No."
                                        [(ngModel)]="newComponentPartNo" />



                                    <div>
                                        <select id="type" class="newcomps"
                                            style="margin-right: 23px!important; min-width: 200px;height: 40px; 
                                    display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                            placeholder="Select Type" [(ngModel)]="newComponentTypeId" ngDefaultControl
                                            required class="select-measurement-point">
                                            <option value="0"></option>
                                            <option [value]="type.Id" *ngFor="let type of componentTypeList">
                                                {{type.Name}}
                                            </option>
                                        </select>

                                        <div style="    margin-left: 15%;">
                                            <a class="button" (click)="addNewComponentType()"><i
                                                    class="material-icons button__icon"> add_circle_outline</i><span
                                                    class="button__text">New Type</span></a>
                                        </div>

                                    </div>

                                    <input type="text" class="newcomps"
                                        style="margin-right: 23px!important;min-width: 200px;height: 40px; 
                                display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                        (keyup.enter)="addNewComponent(scrollTarget)" placeholder="Enter Budget Life"
                                        [(ngModel)]="newcompBudgetLife" />

                                    <mat-checkbox id="newComCritical" [(ngModel)]="newComponentCritical"
                                        [checked]="newComponentCritical"
                                        style="margin-left: 16px!important; margin-right: 16px!important;"
                                        color="primary" (change)="isCriticalChangedevent($event)">
                                    </mat-checkbox>
                                    <mat-checkbox id="newGETCritical" [(ngModel)]="isGETCritical"
                                        [checked]="isGETCritical"
                                        style="margin-left: 16px!important; margin-right: 16px!important;"
                                        color="primary"  (change)="isGETChangedevent($event)">
                                    </mat-checkbox>



                                    <a class="button" style="height:0%" (click)="addNewComponent(scrollTarget)"><i
                                            class="material-icons button__icon">add</i><span
                                            class="button__text">Add</span></a>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div>
                        <button mat-raised-button (click)="goBackStep()">Back</button>
                        <button mat-raised-button color="warn" (click)="goToStep(2)">Next</button>
                    </div>
                </div>
            </mat-step>

            <mat-step>

                <ng-template matStepLabel>Observation Points Setup</ng-template>
                <div class="step-container">

                    <div class="margin-bottom-24">
                        1. Select Schematic to add observation points <i>(Click on thumbnail)</i>
                    </div>

                    <div class="margin-bottom-24" style="overflow-x: auto; white-space: nowrap">
                        <ng-container *ngFor="let sch of schematicList">
                            <div class="implement-image-container2" (click)="openSchematicWindow(sch, 2)"
                                matTooltip="Click to view enlarged schematic.">
                                <img [src]="getImage(sch.Data)" style="width: 100%; height: 100%;" />
                            </div>
                        </ng-container>
                    </div>

                    <div oncontextmenu="return false;">
                        <div>
                            <div class="question__text">2. Add Observation Points (OP) to each Component <i>(clicking on
                                    image where observation point is required)(enter multiple OP for each component as
                                    required)</i></div>
                            <input class="no-grow newCompInput_Select" (keyup)="onObservationNameFilterChange()"
                                type="text" placeholder="Filter list" [(ngModel)]="observationListFilter" />
                            <mat-checkbox id="cbHideSelectedOPs" (checked)="hideSelectedOPs"
                                (click)="toggleSelectedOPs()" color="primary">Hide Selected</mat-checkbox>
                            <mat-checkbox id="cbHideUnselectedOPs" (checked)="hideUnselectedOPs"
                                (click)="toggleUnselectedOPs()" color="primary">Hide Unselected</mat-checkbox>
                        </div>

                        <table class="table relative" style="display: block; overflow-x: auto;">
                            <thead>
                                <tr>
                                    <th>
                                        <mat-checkbox color="primary" [(ngModel)]="cbAllObservationSelect"
                                            (click)="toggleAllObsevations(!cbAllObservationSelect)"
                                            style=" margin-right: 16px!important;"></mat-checkbox>Component
                                    </th>
                                    <th>Obs. Point</th>
                                    <th>Obs. Question</th>
                                    <th>Obs. Type</th>
                                    <th>Obs. List</th>
                                    <th># of Readings Req.</th>
                                    <th>New Limit</th>
                                    <th>Used Limit</th>
                                    <th>Limit Range</th>
                                    <th>Measurement</th>
                                    <th>Question Instructions</th>
                                    <th>Image</th>
                                    <th>Make</th>
                                    <th>Part No.</th>
                                    <th>Active/InActive</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let OP of observationListFiltered">
                                    <tr (mouseover)="onMouseOverOP(OP.Id)" (mouseout)="onMouseOutOP(OP.Id)"
                                        [class.tr-hover]="OP.Id == mouseoverOPId"
                                        *ngIf="selectionLogicForOPs(OP.Selected)">
                                        <td>
                                            <mat-checkbox style="margin-left: 18px;" [checked]="OP.Selected"
                                                [value]="OP.Id" color="primary"
                                                (change)="onObservationListControlChanged(OP.Id, OP.Name)">
                                                {{OP.ComponentName}}</mat-checkbox>
                                        </td>
                                        <td [class.cell-to-update]="highlightName(OP.Name)">
                                            <input id="OPName" placeholder="Name" type="text" [(ngModel)]="OP.Name"
                                                class="length-input newCompInput_Select"
                                                (contextmenu)="displayContextMenu($event, false, OP.Id, 'ObservationPointName')"
                                                required (focusout)="checkExistingOP(OP.Name)">
                                        </td>

                                        <td [class.cell-to-update]="highlightQName(OP.QName)">
                                            <input id="OPQName" placeholder="No Question" type="text"
                                                [(ngModel)]="OP.QName" class="length-input newCompInput_Select"
                                                (contextmenu)="displayContextMenu($event, false, OP.Id, 'ObservationPointQName')"
                                                (focusout)="checkExistingOP(OP.Name)">
                                        </td>
                                        <td [class.cell-to-update]="highlightType(OP.ObservationPointType)">
                                            <select id="OPType" placeholder="Normal/Crack/Evaluation"
                                                [(ngModel)]="OP.ObservationPointType" ngDefaultControl required
                                                class="length-input"
                                                style="height: 40px; 
                                            display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                (contextmenu)="displayContextMenu($event, false, OP.Id, 'ObservationPointType')"
                                                required>
                                                <option value="0"></option>
                                                <option [value]="opt.Id" *ngFor="let opt of observationPointTypes">
                                                    {{opt.Name}}
                                                </option>
                                            </select>
                                        </td>
                                        <td
                                            [class.cell-to-update]="highlightObservationList(OP.ObservationListIds) == 2">
                                            <mat-form-field style="width: 140px">
                                                <mat-select id="Ob_List" class="length-input3"
                                                    style="min-width: 140px; height: 40px; 
                                        display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                    placeholder="Select Observation List" multiple
                                                    [(ngModel)]="OP.ObservationListIds" ngDefaultControl
                                                    (contextmenu)="displayContextMenu($event, OP.ObservationListIds, OP.Id, 'ObservationList')">
                                                    <mat-option *ngFor="let obs of observationLists" [value]="obs.Id">
                                                        {{obs.Name}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                        </td>
                                        <td [class.cell-to-update]="highlightNumberOfReadings(OP.NumberOfReadings)"
                                            class="length-input2 ">
                                            <input id="NumberOfReadings" type="number" [(ngModel)]="OP.NumberOfReadings"
                                                style=" height: 40px; 
                                        display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                (focusout)="onNumReadingsEntered(OP, $event)" class="length-input2 "
                                                min="0" max="5" step="1"
                                                (contextmenu)="displayContextMenu($event, false, OP.NumberOfReadings, 'NumberOfReadings')"
                                                (keypress)="ValidateNumberInputs($event)">
                                        </td>



                                        <ng-container *ngIf="OP.LimitNew==0 && OP.LimitScrap==0">
                                            <td
                                                [class.cell-to-update]="highlightLimitNew(OP.LimitNew, OP.LimitScrap) == 2">
                                                <input id="LimitNew" placeholder="New Limit" type="number"
                                                    style=" height: 40px; 
                                            display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                    [(ngModel)]="OP.LimitNew" class="length-input2" step="0.1" min="0"
                                                    (focusout)="onLimitsEntered(OP, $event)"
                                                    (contextmenu)="displayContextMenu($event, false, OP.Id, 'LimitNew')"
                                                    (keypress)="ValidateNumberInputs($event)">
                                            </td>
                                            <td
                                                [class.cell-to-update]="highlightLimitScrap(OP.LimitNew, OP.LimitScrap) == 2">
                                                <input id="LimitScrap" placeholder="Used Limit" type="number"
                                                    style="height: 40px; 
                                            display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                    [(ngModel)]="OP.LimitScrap" class="length-input2" step="0.1" min="0"
                                                    (focusout)="onLimitsEntered(OP, $event)"
                                                    (contextmenu)="displayContextMenu($event, false, OP.Id, 'LimitScrap')"
                                                    (keypress)="ValidateNumberInputs($event)">
                                            </td>
                                        </ng-container>




                                        <ng-container *ngIf="OP.LimitNew!=0 || OP.LimitScrap!=0">
                                            <td
                                                [class.cell-to-update]="highlightLimitNew(OP.LimitNew, OP.LimitScrap) == 2">
                                                <input id="LimitNew" placeholder="New Limit" type="number"
                                                    style=" height: 40px; 
                                            display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                    [(ngModel)]="OP.LimitNew" class="length-input2" step="0.1" min="0"
                                                    (focusout)="onLimitsEntered(OP, $event)"
                                                    (contextmenu)="displayContextMenu($event, false, OP.Id, 'LimitNew')"
                                                    (keypress)="ValidateNumberInputs($event)">
                                            </td>
                                            <td
                                                [class.cell-to-update]="highlightLimitScrap(OP.LimitNew, OP.LimitScrap) == 2">
                                                <input id="LimitScrap" placeholder="Used Limit" type="number"
                                                    style=" height: 40px; 
                                            display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                    [(ngModel)]="OP.LimitScrap" class="length-input2" step="0.1" min="0"
                                                    (focusout)="onLimitsEntered(OP, $event)"
                                                    (contextmenu)="displayContextMenu($event, false, OP.Id, 'LimitScrap')"
                                                    (keypress)="ValidateNumberInputs($event)">
                                            </td>
                                        </ng-container>



                                        <td [class.cell-to-update]="highlightLimitRange(OP.LimitRange)">
                                            <input id="LimitRange" placeholder="Limit Range" type="number"
                                                style=" height: 40px; 
                                        display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                [(ngModel)]="OP.LimitRange" class="length-input2" step="0.1" min="0">
                                        </td>

                                        <td [class.cell-to-update]="highlightMeasurement(OP.Measurement)">
                                            <input id="Measurement" placeholder="Measurement" type="number"
                                                style=" height: 40px; 
                                        display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                [(ngModel)]="OP.Measurement" class="length-input2" step="0.1" min="0">
                                        </td>



                                        <td [class.cell-to-update]="highlightQDesc(OP.QDesc)">
                                            <input id="OPQDesc" placeholder="No Description" type="text"
                                                style=" height: 40px; 
                                        display: inline !important; border: none;background-color: #F4F7FA; color: #1D2F36; min-height: 40px; padding: 10px;"
                                                [(ngModel)]="OP.QDesc" class="length-input"
                                                (contextmenu)="displayContextMenu($event, false, OP.Id, 'ObservationPointQDesc')">
                                        </td>
                                        <td style="text-align: center;">
                                            <input hidden type='file' (change)="onSelectOPQuestionImage($event,OP.Id)"
                                                #uploadImage>
                                            <div style="margin-left: 30px" class="input-container">
                                                <div>
                                                    <i (click)="uploadImage.click()" *ngIf="!OP.QuestionImage"
                                                        class="material-icons">note_add</i>
                                                    <img (click)="uploadImage.click()" style="width:50px; height:50px"
                                                        *ngIf="OP.QuestionImage" [src]="sanitize(OP.QuestionImage)">

                                                    <mat-icon *ngIf="OP.QuestionImage"
                                                        style="margin-left: -7px;cursor: pointer;"
                                                        (click)="deleteQuestionimage(OP.Id,OP.IsNewImage)">delete
                                                    </mat-icon>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div style="margin-left: 30px">
                                                {{getMakeById(OP.ComponentMake)}}
                                            </div>
                                        </td>
                                        <td>
                                            <div style="margin-left: 30px">
                                                {{OP.ComponentPartNo}}
                                            </div>
                                        </td>
                                        <td>
                                            <div style="margin-left: 30px">
                                                <ui-switch [(ngModel)]="OP.Active"></ui-switch>

                                            </div>
                                        </td>

                                        <td>
                                            <div style="margin-left: 30px">
                                                <i style="color:red;" class="material-icons"
                                                    (click)="deleteOP(OP)">delete_outline</i>

                                            </div>
                                        </td>
                                  <!-- show edit icon -->
                                  <ng-container *ngIf="OP.InspectionDate=='Never'">
                                        <td> 
                                            <div style="margin-left: 30px">
                                                <i class="material-icons"
                                                (click)="openSchematicWindowforEdit(OP.Id, 2)">edit</i>
                                               
                                            </div>
                                        </td>
                                    </ng-container>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                        <br />
                        <div *ngIf="isvalidStep3">
                            <mat-checkbox *ngIf="HasChildImplements" [checked]="false" color="primary"
                                [(ngModel)]="cbApplyToAll" (change)="checkValueAll(cbApplyToAll)">Apply to all
                                Implements
                            </mat-checkbox>
                            <mat-checkbox [checked]="false" color="primary" [(ngModel)]="cbApplyToOne"
                                (change)="checkValueOne(cbApplyToOne)">Apply to this Implement</mat-checkbox>
                        </div>
                        <br />
                        <div>
                            <button mat-raised-button (click)="goBackStep()">Back</button>
                            <button mat-raised-button color="warn" (click)="goToStep(3)"
                                [disabled]="!stepThreeIsValid()" (mouseover)="CheckChanges()">Next</button>
                        </div>
                    </div>

                </div>
            </mat-step>

            <mat-step>
                <div class="step-container">
                    <ng-template matStepLabel>Models Setup</ng-template>

                    <div *ngIf="equipmentOrInventory!='3'">

                        <div class="question">
                            <div class="question__text">Select all models this Implement fits</div>
                            <div>
                                <div class="question__control flex-container row"
                                    style="justify-content: space-between;">
                                    <div style="    min-width: 50%; max-width: 40%;">
                                        <div class="labellist">Family</div>
                                        <div style="min-width: 40%;">
                                            <mat-chip-list #chipList>
                                                <mat-chip *ngFor="let item of filteredFamilyList"
                                                    [selectable]="selectable" [removable]="removable"
                                                    (removed)="removeFamily(item)">
                                                    {{item.Name}}
                                                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                                </mat-chip>

                                            </mat-chip-list>
                                        </div>
                                        <mat-selection-list #types class="matlist" [(ngModel)]="selectedFamilyList" style="min-width: 50%;"
                                            (selectionChange)="onSelectionFamily($event, types.selectedOptions.selected)">
                                            <mat-list-option
                                                *ngFor="let type of _favouriteDialogService.availableFamilyList"
                                                [value]="type.Id">
                                                {{type.Name}}
                                            </mat-list-option>
                                        </mat-selection-list>
                                    </div>

                                    <div style=" min-width: 50%;">
                                        <div class="flex-container row" style="    justify-content: space-between">
                                            <div class="labellist">Available Models</div>
                                            <div class="labellist">Selected Models</div>
                                        </div>
                                        <dual-list key="Id" display="Name" [source]="source" [(destination)]="target"
                                            class="duallist">
                                        </dual-list>
                                    </div>

                                </div>

                                <div style="    min-width: 50%; max-width: 40%;">
                                    <div class="labellist">Make</div>
                                    <div style="min-width: 40%;">
                                        <mat-chip-list #chipList>
                                            <mat-chip *ngFor="let item of filteredMakeList" [selectable]="selectable"
                                                [removable]="removable" (removed)="removeMake(item)">
                                                {{item.Name}}
                                                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                            </mat-chip>

                                        </mat-chip-list>
                                    </div>

                                    <mat-selection-list #makes class="matlist" [(ngModel)]="selectedMakeList" style="min-width: 50%;"
                                        (selectionChange)="onSelectionMake($event, makes.selectedOptions.selected)">
                                        <mat-list-option *ngFor="let make of makeList" [value]="make.Id">
                                            {{make.Name}}
                                        </mat-list-option>
                                    </mat-selection-list>
                                </div>




                            </div>
                        </div>


                    </div>


                    <div *ngIf="equipmentOrInventory=='3'">

                        <div class="question">
                            <div class="question__text">Select all models this Implement fits</div>
                            <div style="pointer-events: none; opacity: 0.5;">
                                <div class="question__control flex-container row"
                                    style="justify-content:space-between;">
                                    <div style="    min-width: 40%;
                                max-width: 40%;">
                                        <div class="labellist">Family</div>
                                        <div style="min-width: 40%;">
                                            <mat-chip-list #chipList>
                                                <mat-chip *ngFor="let item of filteredFamilyList"
                                                    [selectable]="selectable" [removable]="removable"
                                                    (removed)="removeFamily(item)">
                                                    {{item.Name}}
                                                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                                </mat-chip>

                                            </mat-chip-list>
                                        </div>
                                        <mat-selection-list #types class="matlist" [(ngModel)]="selectedFamilyList"
                                            (selectionChange)="onSelectionFamily($event, types.selectedOptions.selected)">
                                            <mat-list-option
                                                *ngFor="let type of _favouriteDialogService.availableFamilyList"
                                                [value]="type.Id">
                                                {{type.Name}}
                                            </mat-list-option>
                                        </mat-selection-list>
                                    </div>

                                    <div style=" min-width: 50%;">
                                        <div class="flex-container row" style="    justify-content: space-between">
                                            <div class="labellist">Available Models</div>
                                            <div class="labellist">Selected Models</div>
                                        </div>
                                        <dual-list key="Id" display="Name" [source]="source" [(destination)]="target"
                                            class="duallist">
                                        </dual-list>
                                    </div>

                                </div>

                                <div style="    min-width: 40%;
                                max-width: 40%;">
                                    <div class="labellist">Make</div>
                                    <div style="min-width: 40%;">
                                        <mat-chip-list #chipList>
                                            <mat-chip *ngFor="let item of filteredMakeList" [selectable]="selectable"
                                                [removable]="removable" (removed)="removeMake(item)">
                                                {{item.Name}}
                                                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                            </mat-chip>

                                        </mat-chip-list>
                                    </div>

                                    <mat-selection-list #makes class="matlist" [(ngModel)]="selectedMakeList"
                                        (selectionChange)="onSelectionMake($event, makes.selectedOptions.selected)">
                                        <mat-list-option *ngFor="let make of makeList" [value]="make.Id">
                                            {{make.Name}}
                                        </mat-list-option>
                                    </mat-selection-list>
                                </div>




                            </div>
                        </div>


                    </div>

                    <div>
                        <button mat-raised-button (click)="goBackStep()">Back</button>
                        <button mat-raised-button color="warn" (click)="mapArry()">Save</button>
                    </div>
                </div>
            </mat-step>

        </mat-horizontal-stepper>

        <apply-selection *ngIf="showContextMenu" [positionX]="contextMenuX" [positionY]="contextMenuY"
            (selectAll)="copySelectionToAll($event)" (selectVacant)="copySelectionToVacant($event)"
            (showAll)="toggleAllCells($event)" (showVacant)="toggleVacantCells($event)"></apply-selection>

    </div>
</div>


<!--Dragable POP UP Code-->
<!-- 
<schemantic-op-popup *ngIf="showSchematic" [(positionX)]="schematicPositionX" [(positionY)]="schematicPositionY"
    [(currentStep)]="currentStep" [(mouseoverMPId)]="mouseoverMPId" [(mouseoverOPId)]="mouseoverOPId"
    [(CustomerId)]="selectedCustomer" [(ImplementId)]="selectedImplement" (mouseoverMP)="onMouseOverMP($event)"
    (mouseoverOP)="onMouseOverOP($event)" [schematic]="selectedSchematic"
    (closeSchematicWindow)="onCloseSchematicWindow($event);" (saveObservation)="onSaveObservation($event)"
    (mousedown)="onMouseButton_Schematic($event)" (mouseup)="onMouseButton_Schematic($event)"
    (mousemove)="onMouseMove_Schematic($event)" [(title)]="draggableSchematicTitle" [(isTemplate)]="isTemplate"></schemantic-op-popup> -->

    <schemantic-op-popup *ngIf="showSchematic" [(positionX)]="schematicPositionX" [(positionY)]="schematicPositionY"
    [(currentStep)]="currentStep" [(mouseoverMPId)]="mouseoverMPId" [(mouseoverOPId)]="mouseoverOPId" 
    [(CustomerId)]="selectedCustomer" [(ImplementId)]="selectedImplement" 
  [schematic]="selectedSchematic"
    (closeSchematicWindow)="onCloseSchematicWindow($event);" (saveObservation)="onSaveObservation($event)" 
     [(title)]="draggableSchematicTitle" [(isTemplate)]="isTemplate"></schemantic-op-popup>


    